(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
    const PARTICIPANT_CONFIG = {
      required: window.PARTICIPANT_REQUIRED || false,
      maxParticipants: 30
    };

    function validateParticipantFields(container, quantityInput) {
      const quantity = parseInt(quantityInput.value) || 1;
      let hasError = false;

      for (let i = 1; i <= quantity; i++) {
        const input = document.getElementById('participant-' + i);
        const error = document.getElementById('participant-' + i + '-error');

        if (input && !input.value.trim()) {
          hasError = true;
          input.classList.add('participant-names__input--error');
          if (error) error.classList.add('participant-names__error--visible');
        } else if (input) {
          input.classList.remove('participant-names__input--error');
          if (error) error.classList.remove('participant-names__error--visible');
        }
      }

      if (hasError) {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return !hasError;
    }

    function initParticipantNames() {
      const container = document.getElementById('participant-names-container');
      const fieldsContainer = document.getElementById('participant-names-fields');
      
      if (!container || !fieldsContainer) return;

      const productForm = container.closest('form[action="/cart/add"]') || document.querySelector('form[data-type="add-to-cart-form"]');
      const quantityInput = productForm ? productForm.querySelector('[name="quantity"]') : document.querySelector('[name="quantity"]');

      if (!quantityInput || !productForm) return;

      let currentQuantity = parseInt(quantityInput.value) || 1;

      function updateFields(quantity) {
        quantity = Math.min(Math.max(1, quantity), PARTICIPANT_CONFIG.maxParticipants);

        container.style.display = 'block';
        
        // Mevcut değerleri sakla
        const existingValues = {};
        fieldsContainer.querySelectorAll('input').forEach(input => {
          existingValues[input.name] = input.value;
        });

        let fieldsHTML = '';
        
        // 1. katılımcı her zaman gösterilir, 2+ quantity'de ek alanlar eklenir
        for (let i = 1; i <= quantity; i++) {
          const labelText = quantity === 1 ? 'Katılımcı Adı' : i + '. Katılımcı Adı';
          const fieldName = quantity === 1 ? 'properties[Katılımcı]' : 'properties[' + i + '. Katılımcı]';
          const existingValue = existingValues[fieldName] || '';
          const requiredClass = PARTICIPANT_CONFIG.required ? 'participant-names__label--required' : '';
          const requiredAttr = PARTICIPANT_CONFIG.required ? 'required' : '';
          
          fieldsHTML += '<div class="participant-names__field">' +
            '<label class="participant-names__label ' + requiredClass + '" for="participant-' + i + '">' +
              labelText +
            '</label>' +
            '<input ' +
              'type="text" ' +
              'id="participant-' + i + '" ' +
              'name="' + fieldName + '" ' +
              'class="participant-names__input" ' +
              'placeholder="Ad Soyad" ' +
              'value="' + existingValue + '" ' +
              requiredAttr +
            '>' +
            '<span class="participant-names__error" id="participant-' + i + '-error">' +
              'Bu alan zorunludur' +
            '</span>' +
          '</div>';
        }

        fieldsContainer.innerHTML = fieldsHTML;
      }

      // Quantity değişikliklerini dinle
      quantityInput.addEventListener('change', function() {
        updateFields(parseInt(this.value) || 1);
      });

      quantityInput.addEventListener('input', function() {
        updateFields(parseInt(this.value) || 1);
      });

      // +/- butonları için - quantity wrapper'daki tüm click eventlerini dinle
      const quantityWrapper = quantityInput.closest('.quantity-selector') || quantityInput.closest('.quantity') || quantityInput.parentElement;
      if (quantityWrapper) {
        quantityWrapper.addEventListener('click', function() {
          setTimeout(function() {
            const newQuantity = parseInt(quantityInput.value) || 1;
            if (newQuantity !== currentQuantity) {
              currentQuantity = newQuantity;
              updateFields(newQuantity);
            }
          }, 50);
        });
      }

      // MutationObserver ile value attribute değişikliklerini izle
      const observer = new MutationObserver(function() {
        const newQuantity = parseInt(quantityInput.value) || 1;
        if (newQuantity !== currentQuantity) {
          currentQuantity = newQuantity;
          updateFields(newQuantity);
        }
      });

      observer.observe(quantityInput, { 
        attributes: true, 
        attributeFilter: ['value'] 
      });

      // Form submit validasyonu (zorunlu modda - kişi sayısından bağımsız)
      if (PARTICIPANT_CONFIG.required) {
        productForm.addEventListener('submit', function(e) {
          if (!validateParticipantFields(container, quantityInput)) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      // "Hemen satın al" (Buy it now / accelerated checkout) butonlarını yakala
      if (PARTICIPANT_CONFIG.required) {
        // Shopify accelerated checkout butonları genelde .shopify-payment-button içinde olur
        const formWrapper = productForm.closest('.product-form-buttons') || productForm.parentElement;
        
        function interceptBuyNow() {
          // Shopify Payment Button (.shopify-payment-button) ve içindeki butonları bul
          const buyNowButtons = formWrapper ? formWrapper.querySelectorAll('.shopify-payment-button button, .shopify-payment-button .shopify-payment-button__button, [data-shopify="payment-button"] button') : [];
          
          buyNowButtons.forEach(function(btn) {
            if (btn.dataset.participantIntercepted) return;
            btn.dataset.participantIntercepted = 'true';
            
            btn.addEventListener('click', function(e) {
              if (!validateParticipantFields(container, quantityInput)) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
              }
            }, true); // capture phase ile yakala
          });
        }

        // İlk yüklemede ve DOM değişikliklerinde butonları yakala
        interceptBuyNow();
        
        // Shopify payment button'ları geç yüklenebilir, MutationObserver ile izle
        const buyNowObserver = new MutationObserver(function() {
          interceptBuyNow();
        });

        if (formWrapper) {
          buyNowObserver.observe(formWrapper, { 
            childList: true, 
            subtree: true 
          });
        }

        // Ek güvenlik: document seviyesinde de yakala
        document.addEventListener('click', function(e) {
          const buyNowBtn = e.target.closest('.shopify-payment-button button, .shopify-payment-button .shopify-payment-button__button, [data-shopify="payment-button"] button');
          if (buyNowBtn) {
            if (!validateParticipantFields(container, quantityInput)) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return false;
            }
          }
        }, true); // capture phase
      }

      // Input değiştiğinde error'ı kaldır
      fieldsContainer.addEventListener('input', function(e) {
        if (e.target.classList.contains('participant-names__input')) {
          e.target.classList.remove('participant-names__input--error');
          const errorEl = document.getElementById(e.target.id + '-error');
          if (errorEl) errorEl.classList.remove('participant-names__error--visible');
        }
      });

      // Sayfa yüklendiğinde mevcut quantity'e göre güncelle
      updateFields(currentQuantity);
    }

    // DOM hazır olduğunda başlat
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParticipantNames);
    } else {
      initParticipantNames();
    }

    // Shopify section render eventini dinle (AJAX güncellemeleri için)
    document.addEventListener('shopify:section:load', initParticipantNames);
  })();
  } catch(e) { console.error(e); }
})();

})();
